import { Cards } from 'components/Cards';
import { Hero } from 'components/Hero';
import { QrCodeBlock } from 'components/QrCodeBlock';
import { ContactForm } from 'components/ContactForm';
import { PatternCards } from 'components/PatternCards';
import { FAQ } from 'components/FaqSection';
import { Abbreviation } from 'components/Abbreviation';
import { Accessibility } from 'components/Accessibility';
import { DownloadCta } from 'components/DownloadCta';

export const Content = () => {
  return (
    <main>
      <Hero />
      <QrCodeBlock />
      <PatternCards/>
      <Cards />
      <Accessibility />
      <DownloadCta />
      <Abbreviation />
      <FAQ />
      <ContactForm />
    </main>
  );
};
